export const getCustomFieldFromWorker = (worker: any, fieldName: string) => {
  const customfield = worker?.customFields?.find((cf: any) => cf?.name === fieldName);
  return customfield?.value ?? null;
};
